const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export function isValidEmail(email: string): boolean {
  return emailRegex.test(email);
}

// https://docs.peppol.eu/edelivery/codelists/v9.4/Peppol%20Code%20Lists%20-%20Participant%20identifier%20schemes%20v9.4.json

const beVATRegex = /^BE[01][0-9]{9}$/;
export function isValidVAT(countryCode: string, vat: string): boolean | undefined {
    switch (countryCode.toUpperCase()) {
        case "BE":
            {
                return beVATRegex.test(vat.toUpperCase());
            }
    }
    return undefined;
}

const IBANRegex = /^[A-Z]{2}[0-9]{2}[A-Z-0-9]{11,30}$/;
export function isValidIBAN(countryCode: string, vat: string): boolean | undefined {
    return IBANRegex.test(vat.toUpperCase());
}

/**
 * Validate Belgian SEPA structured communication
 * Format: +++123/4567/89101+++
 * - Always 12 digits (10 base + 2 check)
 * - Wrapped with +++ at start and end
 * - Slashes at positions 3 and 7
 * - Check digit = number % 97 (with 97 if remainder = 0)
 */
export function isValidStructuredCommunication(input: string): boolean {
    // Regex for format +++123/4567/89101+++
    const regex = /^\+\+\+\d{3}\/\d{4}\/\d{5}\+\+\+$/;
    if (!regex.test(input)) return false;

    // Extract digits only
    const digits = input.replace(/[^\d]/g, "");
    if (digits.length !== 12) return false;

    const base = digits.substring(0, 10);
    const check = parseInt(digits.substring(10), 10);

    const num = parseInt(base, 10);
    let expected = num % 97;
    if (expected === 0) expected = 97;

    return check === expected;
}

export function tryConvertToValidStructuredCommunication(input: string | undefined): string | undefined {
    if (!input) return input;
    // Extract digits only
    const digits = input.replace(/[^\d]/g, "");
    if (digits.length !== 12) return input;

    const base = digits.substring(0, 10);
    const check = parseInt(digits.substring(10), 10);

    const num = parseInt(base, 10);
    let expected = num % 97;
    if (expected === 0) expected = 97;

    if (check === expected) {
        return "+++" + digits.substring(0,3) + "/" + digits.substring(3,7) + "/" + digits.substring(7,12) + "+++";
    }
    return input;
}